import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import {connect} from 'react-redux'
import ROUTES from './../../constants/routes';
import './../../css/acc-link.css';
import './../../css/SingleCard.css';
import DiscoverCard from './../../images/discover-card.png';
import {Logo} from './../../components/common/Logo/Logo.js';
import spinner from './../../Spinnerimage.gif';
import {HttpStatusCode, ResultCodes, Messages} from './../../constants/utilities';
import AxiosDataService from '../../services/AxiosDataService';
import {OnSingleCardPageLoad,OnSingleCardCancel,OnSingleCardLinkNow,OnLinkingSuccess} from './../../components/SiteCat/SiteCat'
import {getMerchantData,onUserCancel,formatPhoneNumber,isRealPhoneNumber} from './../../constants/merchantData';
import LinkContent from "../../components/common/privacydata/LinkContent";
import LinkContentPaypal from '../../components/common/privacydata/LinkContentPaypal';
import Config from './../../constants/config';

class SingleCard extends Component {
  constructor(props, context) {
    super(props, context);


    this.state = {
      eligibleAccountVO: [],
      singlecardresponse: "",
      doRedirect: false,
      pageName: "",
      isLoaded: false,
      locationhref: "",
      merchantName:"",
      selectedCarddigits:"",
      authCode:""
    };
  }

  handleCancel = event => {
    OnSingleCardCancel(this.state.merchantName);
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    onUserCancel(data);
  }

  handleLinkcard = event => {
    OnSingleCardLinkNow(this.state.merchantName);
    event.preventDefault();
    this.setState({
      isLoaded: true
      
    })
    let randomstring = require('random-string');
    const singleCardLinkId = this.state.singlecardresponse.linkId
    const singleCardAccKey = this.state.singlecardresponse.eligibleAccountVO[0].accntKey
    const singleCardNumLast = this.state.singlecardresponse.eligibleAccountVO[0].last4AcctNbr
    this.setState({ selectedCarddigits: singleCardNumLast })
    let singleCardData = {
      accountKeys: [
        singleCardAccKey
      ],
      linkId: singleCardLinkId,
      merchantName: this.state.merchantName,
      sessionID: this.props.posts.sessionID
    }
    const self = this;
      const options = {
      url: "linkFinancialInstrument",// + Config.env,
      method: "post",
      timeout: 8000,
      headers: {
        "Access-Control-Allow-Origin": "*",
        //"HTTP_AUTH_TOKEN": self.state.jwtTokenData,
        'Content-Type': 'application/json',
        "REQUEST_ID": randomstring({ length: 20 })
      },
      data: JSON.stringify(singleCardData)
    };
    AxiosDataService.fetch(options).then((responsedata) => {
        self.setState({
          isLoaded: false
        })
        let response=responsedata.data;
        
	  //Storing Response in Reducer
        self.props.dispatch({
          type:'LINKFI_RESPONSE',
           response,
           selectedCarddigits: self.state.selectedCarddigits,
           last4Digit:self.state.last4Digit,
           fromLinkNow:true
           
          });
          
        if (response.responseOutput.returnCode === "0") {
          if (response.resultCode === ResultCodes.RA_DENY) {
            self.setState({
              pageName: "RaDeny",
              doRedirect: true
            });

          } else if (response.resultCode === ResultCodes.NO_CONTACT_CHNL) {
            self.setState({
              pageName: "NoContactChannel",
              doRedirect: true
            });

          } else if (response.resultCode === ResultCodes.CONTACT_SELECTION_PAGE) {
            self.setState({
              pageName: "ContactChannels",
              doRedirect: true
            });

          } else if (response.resultCode === ResultCodes.MERCHANT_REDIRECT_PAGE) {
            OnLinkingSuccess(this.state.merchantName);
            const redirecturl = response.partnerRedirectVO.href
            self.setState({
              pageName: "RedirectPage",
              doRedirect: true,
              locationhref: redirecturl
            });
          }  else if (response.resultCode === ResultCodes.CID_PAGE) {
            const singleCardNum = self.state.singlecardresponse.eligibleAccountVO[0].last4AcctNbr
            self.setState({
              pageName: "CardSecurePage",
              doRedirect: true,
              singleCardNum: singleCardNum
             
            });

          } else {
            
          }
        } else {
          console.log("retun code is not Zero.");
        }

      },(errorResponse) => {
        self.setState({
          isLoaded: false
        })
        let error = errorResponse.response;
        
        let response=error.data;
        if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR || error.status === HttpStatusCode.NOT_FOUND) {

          
          self.setState({
            pageName: "TechDiff",
            doRedirect: true
          });

        }else if (error.statusText === "timeout" || error.status === 0) {
          console.log("Api time out")
          self.setState({
            pageName: "TechDiff",
            doRedirect: true
          });
        } else if (response.returnCode === ResultCodes.TECH_DIFF_FI_DOWN || response.returnCode === ResultCodes.TECH_DIFF_RA_DOWN || response.returnCode === ResultCodes.TECH_DIFF_DPL_DOWN || response.returnCode === ResultCodes.TECH_DIFF_CACHE_DOWN || response.returnCode === ResultCodes.TECH_DIFF_NO_LINK_ACTIVITY) {
          self.setState({
            pageName: "TechDiff",
            doRedirect: true
          });
        } else {
          self.setState({
            pageName: "TechDiff",
            doRedirect: true
          });
        }
    }).catch((e)=>{
      console.log("API time out ");
      self.setState({
        pageName: "TechDiff",
        doRedirect: true
      });
    });
  }

  componentWillMount = () => {
    this.setState({
      merchantName : this.props.posts.merchant,
      authCode : this.props.posts.authcode
    });
  }

  componentDidMount() {
    OnSingleCardPageLoad(this.state.merchantName);
    const loginresposnestate = this.props.posts.loginresponse
    const jwtTokenData = this.props.posts.jwtToken.jwtToken
    var cancelUrlData = null;
    if (this.state.merchantName === 'amazon') {
        cancelUrlData = this.props.posts.cancelUrl
    }else {
      cancelUrlData = this.props.posts.jwtToken.cancelUrl
    }
 this.setState({
      singlecardresponse: loginresposnestate,
      eligibleAccountVO: loginresposnestate.eligibleAccountVO,
      jwtTokenData,
      cancelUrlData,
      last4Digit:this.props.posts.last4Digit
      
    });
  }
  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    const cardImage = undefined;
    if (this.state.doRedirect === true) {
      if (this.state.pageName === "RaDeny") {
        return <Navigate to={ROUTES.PATH.RaDeny} replace />
      } else if (this.state.pageName === "ContactChannels") {
        return <Navigate to={ROUTES.PATH.ContactChannels} replace />
      } else if (this.state.pageName === "NoContactChannel") {
        return <Navigate to={ROUTES.PATH.NoContactChannel} replace />
      } else if (this.state.pageName === "TechDiff") {
        return <Navigate to={ROUTES.PATH.TechDiff} replace />
      } else if (this.state.pageName === "CardSecurePage") {
        return (<Navigate to={{pathname: ROUTES.PATH.CardSecurePage}}
          carddata={{ carddigits: this.state.singleCardNum }}
          replace 
        />);
      }  else if (this.state.pageName === "RedirectPage") {
        return (
          <Navigate to={{pathname: ROUTES.PATH.RedirectPage}}
            state={{ loc: this.state.locationhref }}
            replace
          />
        );
      } else {
        console.log("Route problem")
      }
    } else {
      let isLoadervalue = this.state.isLoaded;

      return (
        <React.Fragment>
           {isLoadervalue ?
               <div className="spinner">
               <img src={spinner} alt="Spinner" />
             </div> : null
          }
          <div className="row">
            <div className="signlecard-blk singlecard-logo col-xs-12 col-sm-6 col-md-6 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div class="paypal-logo">
                <Logo merchantName ={this.state.merchantName}/>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="signlecard-blk col-xs-12 col-sm-6 col-md-6 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <p className="multicard-header">{merchantData.SingleCard.HEADER}</p>
            </div>
          </div>
          <div className="row">
            <div className="signlecard-blk col-xs-12 col-sm-6 col-md-6 col-lg-3 col-md-offset-3 col-lg-offset-4 col-sm-offset-3">
              <div className="topLink" />
              {
                this.state.eligibleAccountVO.map(eligibleAccountVO => {
                  let city_state_pin = `${eligibleAccountVO.billingAddress.city}, ${eligibleAccountVO.billingAddress.state} ${eligibleAccountVO.billingAddress.zipCode}`
                   let emailAddress = ''
                   let emailAddress1 = ''
                   let emailAddress2 = ''
                   let homePhoneNumber =  ''
                  let primMobileNumber =  ''
                  let workPhoneNumber =  ''
                  let encodedCardArt = `${eligibleAccountVO.encodedCardArt}`
                  let cardImageName = `${eligibleAccountVO.cardImageName}`
                  if(this.state.merchantName==='amazon'){
                    emailAddress = `${eligibleAccountVO.emailAddress}`
                    if(emailAddress.length >20){
                      emailAddress1 = emailAddress.split("@")[0]
                      emailAddress2 = ("@" + emailAddress.split("@")[1])
                      emailAddress = ""
                    }
                    //to display phone numbers on priority
                    if(`${eligibleAccountVO.primMobileNumber}` !== "" && isRealPhoneNumber(`${eligibleAccountVO.primMobileNumber}`)){
                      primMobileNumber = `${eligibleAccountVO.primMobileNumber}`
                    }
                    else if(`${eligibleAccountVO.homePhoneNumber}` !== "" && isRealPhoneNumber(`${eligibleAccountVO.homePhoneNumber}`)){
                        homePhoneNumber = `${eligibleAccountVO.homePhoneNumber}`
                    }
                    else if(`${eligibleAccountVO.workPhoneNumber}`  !== "" && isRealPhoneNumber(`${eligibleAccountVO.workPhoneNumber}`)){ 
                        workPhoneNumber = `${eligibleAccountVO.workPhoneNumber}`
                    }
                  }
                  
                 const checkCardImageValue = (value, field) => {
                    if(value !== "null" && value !== null && value !== "" && value !== undefined && value !== "undefined") {
                      console.log(field, "Flow");
                       return true;
                    } else {
                      return false;
                    }
                  }

				      return (
                    <div className="row" key={eligibleAccountVO.accntKey}>

                      <div className="col-xs-5 col-lg-4 col-md-4 col-sm-4 singlecard-img">
                          {checkCardImageValue(cardImageName, "Card Image Name") ? (<img src={Config.cardImageUrl + cardImageName +".gif"} 
                                intialImage={DiscoverCard} class="singlecard-image-size" alt="Discover Card"  />)
                            : checkCardImageValue(encodedCardArt, "Card Art") ? (<img src={`data:image/png;base64,${encodedCardArt}`} 
                                intialImage={DiscoverCard} class="singlecard-image-size" alt="Discover Card"/>)
                            : (<img src={DiscoverCard} class="singlecard-image-size" alt="Discover Card" />)}
                      </div>
                      <div className="col-xs-7 col-lg-7 col-md-7 col-sm-7 single-discrib">

                        <p className="Card-List-Text">{`${eligibleAccountVO.cardProductTypeDesc} (${eligibleAccountVO.last4AcctNbr})`}</p>
                        <p class="glassbox-masked">{`${eligibleAccountVO.firstName} ${eligibleAccountVO.lastName}`}</p>
                        <p class="glassbox-masked">{` ${eligibleAccountVO.billingAddress.addressLine1},  ${eligibleAccountVO.billingAddress.addressLine2}`}</p>
                        <p class="glassbox-masked">{` ${city_state_pin}`}</p>
						            <p class="glassbox-masked">{` ${emailAddress}`}</p>
                        <p class="glassbox-masked">{` ${emailAddress1}`}</p>
                        <p class="glassbox-masked">{` ${emailAddress2}`}</p>
                        <p class="glassbox-masked">{` ${formatPhoneNumber(homePhoneNumber)}`}</p>
                        <p class="glassbox-masked">{` ${formatPhoneNumber(primMobileNumber)}`}</p>
                        <p class="glassbox-masked">{` ${formatPhoneNumber(workPhoneNumber)}`}</p>
                      </div>

                    </div>
                  )
                })
              }
              <div className="bottomLink" />
              <div>
                <p className="siglecard-footer">
                  {this.state.merchantName == "paypal" ? merchantData.SingleCard.MESSAGE : ""}
                </p>
              </div>
              <div>
                  <p className="consenting-head">
                  {this.state.merchantName != "paypal" ? merchantData.MultiCard.MESSAGE: ""}</p>	 
                </div>
              <div className="row multicard-btn">
                <button onClick={this.handleLinkcard}>{merchantData.SingleCard.BUTTON}</button>
              </div>
              <div className="row multicard-cancel">
                <button class="changebtnproperty" onClick={this.handleCancel}>{merchantData.SingleCard.LINK}</button>
              </div>
              <div className="row">
                   <div className="multicard-terms-blk">
                     {this.state.merchantName != "paypal" ? (
                      <div className="termsAndCondition-footer">
                      <p class="termsAndCondition-sub-head">{merchantData.MultiCard.TERMS}
                      {<LinkContent />}
                      </p>
                    </div>
              ) : (
                <div className="termsAndCondition-footer">
                <p class="termsAndCondition-sub-head">{merchantData.SingleCard.TERMS}
                 {<LinkContentPaypal />}
                </p>
                </div>
              )}
            </div>
          </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = (state) => {
    return {
      posts: state
    }
  }
export default connect(mapStateToProps)(SingleCard);
  
